import { Component } from '@angular/core';
import { AuthUser } from '../../../../globalTypes/auth.types';
import { Store } from '@ngrx/store';
import { authUserFeature } from '../../store/authUser.store';
import { JsonPipe } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { LocationPublic } from '../../../../globalTypes/account.types';
import { accountFeature } from '../../store/account.store';
import { filter, lastValueFrom, Subject, take, takeUntil } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { Status } from '../../../../globalTypes/base.types';
import { fulfillmentPageOrders, FulfillmentPageOrdersVariables } from '@dataconnect/account';
import { sleep } from '../../../../globalTypes/_helpers';

@Component({
  selector: 'msh-test-page',
  imports: [JsonPipe],
  template: `
    <p>
      test-page works!
    </p>
    {{user | json}}<br /><br />
    {{locations | json}}<br /><br />
    {{location | json}}<br /><br />
    {{fulfillmentStatusMap | json}}<br /><br />
  `,
  styles: ``
})
export class TestPageComponent {
  user: AuthUser | null = null;
  locations: {[locationId:string]: LocationPublic} = {};
  location: LocationPublic | null = null;
  $destroy: Subject<void> = new Subject<void>();
  fulfillmentStatusMap: {[statusId: string]: Status} = {};
setup = false;
  constructor(
    private store: Store,
    private authService: AuthService,
    private accountService: AccountService,
  ) {
    this.store.select(authUserFeature.selectUser).subscribe(user => {
      this.user = user;

      this.store.select(accountFeature.selectLocations).pipe(takeUntil(this.$destroy), filter(l => !!l)).subscribe(async locations => {
        this.locations = locations as {[locationId:string]: LocationPublic}
        if(!this.location) this.location = await lastValueFrom(this.store.select(accountFeature.selectLocation).pipe(filter(l=>!!l), take(1))) as LocationPublic;
        console.log({location: this.location})
        if(this.setup) return;
        this.setup = true;

        await sleep(100);
        const statuses = await this.accountService.getStatuses('fulfillments');
        this.fulfillmentStatusMap = statuses.reduce((a,s,i)=>{a[s.id]=s; return a;},{} as {[statusId: string]: Status})
        const limit = 10
        const offset = 0;
        const orderVars: FulfillmentPageOrdersVariables = { locationId: this.location.id, limit, offset}
        console.log({orderVars})
        // first load from store,
        //this.fulfillments = await lastValueFrom(this.store.select(ordersFeature.selectOrders).pipe(take(1)))
        // then pull from db
        // other pulls should be as a result of filtering or sorting actions
        await sleep(100);
        try {
          const orderRef = await fulfillmentPageOrders(orderVars); 
          console.log({orderRef})
          console.log('done-ish')
        } catch (error) {
          console.error('Error loading orders for fulfillment page', {error})
        }
      })
    })
  }
}
